<div class="mobile-login-container">
  <div class="mobile-login-log-in-mobile">
    <div class="mobile-login-container1">
      <!-- <img
        alt="SpherePink32776"
        src="/assets/external/spherepink32776-ddud-200h.png"
        class="mobile-login-sphere-pink3"
      /> -->
      <div class="mobile-login-frame459">
        <span class="mobile-login-text">
          <span>
            Por favor, introduzca la información necesaria para acceder y
            actualizar los documentos de datos
          </span>
        </span>
      </div>
      <div class="mobile-login-frame1170">
        <div class="mobile-login-box-mobile-v3">
          <div class="mobile-login-frame168">
            <div class="mobile-login-frame1681">
              <div class="mobile-login-frame1129">
                <div class="mobile-login-frame1130">
                  <div class="mobile-login-frame1128">
                    <span class="mobile-login-text02 Mob,P6-Intro-Bold">
                      <span>Relación</span>
                    </span>
                  </div>
                </div>
                <div class="mobile-login-frame169">
                  <input
                    type="text"
                    placeholder="Madre"
                    class="mobile-login-input"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-login-frame186">
            <div class="mobile-login-frame1682">
              <div class="mobile-login-frame11291">
                <div class="mobile-login-frame11301">
                  <div class="mobile-login-frame11281">
                    <span class="mobile-login-text04 Mob,P6-Intro-Bold">
                      <span>Fecha de Nacimiento</span>
                    </span>
                  </div>
                </div>
                <div class="mobile-login-frame1691">
                  <input
                    type="text"
                    placeholder="Madre"
                    class="mobile-login-input1"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-login-frame185">
            <div class="mobile-login-frame1683">
              <div class="mobile-login-frame11292">
                <div class="mobile-login-frame11302">
                  <div class="mobile-login-frame11282">
                    <span class="mobile-login-text06 Mob,P6-Intro-Bold">
                      <span>Nombres Completos</span>
                    </span>
                  </div>
                </div>
                <div class="mobile-login-frame1692">
                  <input
                    type="text"
                    placeholder="Lira Montoya"
                    class="mobile-login-input2"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-login-frame178">
            <div class="mobile-login-frame1684">
              <div class="mobile-login-frame11293">
                <div class="mobile-login-frame11303">
                  <div class="mobile-login-frame11283">
                    <span class="mobile-login-text08 Mob,P6-Intro-Bold">
                      <span>Número de Pasaporte</span>
                    </span>
                  </div>
                </div>
                <div class="mobile-login-frame1693">
                  <input
                    type="text"
                    placeholder="xxxx-xxxx-xxxxx"
                    class="mobile-login-input3"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-login-cotizar">
            <span class="mobile-login-text10 Mob,H1,Bold,14">
              <span>Continuar Activación</span>
            </span>
          </div>
        </div>
        <div class="mobile-login-frame1134">
          <span class="mobile-login-text12 Mob,P3,Regular12">
            <span>
              Si usted perdió su número de certificado o prefieren hablar con un
              representante, por favor llame por cobrar al +1-305-537-1145.
              También puede enviar un correo electrónico a
              service&#64;blueassist.com
            </span>
            <br />
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
